(function() {
    'use strict';

    angular
        .module('app.cantidades')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/cantidades',
                config: {
                    templateUrl: 'app/cantidades/cantidades.html',
                    controller: 'Cantidades',
                    controllerAs: 'vm',
                    title: 'Cantidades'
                }
            },
            {
                url: '/editar-cantidad/:id?',
                config: {
                    templateUrl: 'app/cantidades/editarCantidad.html',
                    controller: 'EditarCantidad',
                    controllerAs: 'vm',
                    title: 'EditarCantidad'
                }
            }
        ];
    }
})();
